import * as pipes from './pipes';
import * as points from './points';

const map = {
  pipes,
  points,
};
export default map;
